import { render, staticRenderFns } from "./stuclassmobile.vue?vue&type=template&id=e88b67be&scoped=true&"
import script from "./stuclassmobile.vue?vue&type=script&lang=js&"
export * from "./stuclassmobile.vue?vue&type=script&lang=js&"
import style0 from "./stuclassmobile.vue?vue&type=style&index=0&id=e88b67be&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e88b67be",
  null
  
)

export default component.exports